import { InputField } from '@design-system';
import { useTranslation } from 'next-i18next';
import React, { FC } from 'react';
import { useFormContext } from 'react-hook-form';

interface DateOfBirthFieldProps {
  day: string;
  month: string;
  year: string;
}

export const DateOfBirthField: FC = () => {
  const { t } = useTranslation('authentication');

  const form = useFormContext<DateOfBirthFieldProps>();

  const validation = form.formState.errors ?? {};

  const dayError = validation.day?.message as string;
  const monthError = validation.month?.message;
  const yearError = validation.year?.message;
  const dateOfBirthError = yearError ?? dayError ?? monthError;

  return (
    <div className="flex w-full flex-col gap-2">
      <p className="w-full text-xs">
        {t('screens.profile.fields.birthday.label')}
      </p>
      <div className="grid w-full grid-cols-3 gap-3">
        <InputField
          {...form.register('day', { deps: ['month', 'year'] })}
          error={dayError}
          hideErrorMessage
          id="day"
          max={31}
          maxLength={2}
          min={1}
          name="day"
          placeholder={t('screens.profile.fields.birthday.dayPlaceholder')}
          type="number"
        />

        <InputField
          {...form.register('month', { deps: ['day', 'year'] })}
          error={monthError}
          hideErrorMessage
          id="month"
          max={12}
          maxLength={2}
          min={1}
          name="month"
          placeholder={t('screens.profile.fields.birthday.monthPlaceholder')}
          type="number"
        />

        <InputField
          {...form.register('year', { deps: ['day', 'month'] })}
          error={yearError}
          hideErrorMessage
          id="year"
          max={new Date().getFullYear()}
          maxLength={4}
          min={1920}
          name="year"
          placeholder={t('screens.profile.fields.birthday.yearPlaceholder')}
          type="number"
        />
      </div>
      {dateOfBirthError ? (
        <p className="w-full text-xs text-danger-4">{t(dateOfBirthError)}</p>
      ) : null}
    </div>
  );
};
